export default {"src":"/_next/static/media/account_settings.a919d0ad.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};